import api from "./api";

export function run() {
  return new Promise((resolve, reject) => {
    api
      .post("/ir21-ondemand-sync/")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

